import { FormProvider, Controller } from 'react-hook-form';
import { Text } from '@eo-locale/react';
import { Button } from '../../components';
import { Accordion } from '../../components/atoms/Accordion';
import { Checkbox } from '../../components/atoms/Checkbox';
import { agreementsMap } from '../../utils/agreementsMap';
import { useAgreementsModal } from './useAgreementsModal';

interface Props {
    onClose: () => void;
}

export const AgreementsModal = ({ onClose }: Props) => {
    const { handleSubmit, methods, onSubmit, optionalAgreements, requiredAgreements, shouldDisable } = useAgreementsModal({ onClose });

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <h2 className="text-[22px] leading-[26px] font-light mb-4">
                        Aby kontynuować, zaznacz wszystkie wymagane zgody
                    </h2>
                    <div className="space-y-4">
                        <h3 className="text-[18px] leading-[22px] font-medium mb-2 mx-2">Zgody wymagane:</h3>
                        {requiredAgreements.map((agreement, index) => {
                            const Component = agreementsMap?.[agreement?.name] ?? null;

                            return (
                                <Accordion
                                    key={agreement.id}
                                    title={
                                        <div className="flex gap-2 items-center">
                                            <Controller
                                                name={`agreements.${index}.has_agree`}
                                                control={methods.control}
                                                render={({ field }) => (
                                                    <Checkbox
                                                        type="checkbox"
                                                        id={`agreement-${agreement.id}`}
                                                        checked={Boolean(field.value)}
                                                        onChange={(e) =>
                                                            field.onChange(e.target.checked)
                                                        }
                                                    />
                                                )}
                                            />
                                            <div>
                                                <label
                                                    htmlFor={`agreement-${agreement.id}`}
                                                    className="font-medium cursor-pointer"
                                                >
                                                    {agreement.name}
                                                    {Boolean(agreement.required) && '*'}
                                                </label>
                                            </div>
                                        </div>
                                    }
                                >
                                    <div className="p-4 text-[black] rounded-b-lg w-[582px]">
                                        <Component />
                                    </div>
                                </Accordion>
                            );
                        })}
                    </div>
                    <div className="space-y-4 mt-4">
                        <h3 className="text-[18px] leading-[22px] font-medium mb-2 mx-2">Zgody dodatkowe:</h3>
                        {optionalAgreements.map((agreement, index) => {
                            const Component = agreementsMap?.[agreement?.name] ?? null;

                            return (
                                <Accordion
                                    key={agreement.id}
                                    title={
                                        <div className="flex gap-2 items-center">
                                            <Controller
                                                name={`agreements.${requiredAgreements.length + index}.has_agree`}
                                                control={methods.control}
                                                render={({ field }) => (
                                                    <Checkbox
                                                        type="checkbox"
                                                        id={`agreement-${agreement.id}`}
                                                        checked={Boolean(field.value)}
                                                        onChange={(e) =>
                                                            field.onChange(e.target.checked)
                                                        }
                                                    />
                                                )}
                                            />
                                            <div>
                                                <label
                                                    htmlFor={`agreement-${agreement.id}`}
                                                    className="font-medium cursor-pointer"
                                                >
                                                    {agreement.name}
                                                    {Boolean(agreement.required) && '*'}
                                                </label>
                                            </div>
                                        </div>
                                    }
                                >
                                    <div className="p-4 text-[black] rounded-b-lg w-[582px]">
                                        <Component />
                                    </div>
                                </Accordion>
                            );
                        })}
                    </div>
                    <div className="w-full flex justify-center">
                        <Button
                            disabled={shouldDisable}
                            type="submit"
                            className="mt-4 btn mx-auto btn-primary"
                        >
                            <Text id="save" />
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};
